import styled from "@emotion/styled";
import { MDSText, MDSTextVariant, MDSTextWeight } from "@/mds/components/text";
import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";

interface MDSHomeTabProps extends React.PropsWithChildren {
  isActive: boolean;
  isOnlyTab?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

export const MDSHomeTab = ({ isActive, isOnlyTab, onClick }: MDSHomeTabProps) => {
  return (
    <StyledContainer $isActive={isActive} $isOnlyTab={isOnlyTab} onClick={onClick}>
      <StyledTabLabel variant={MDSTextVariant.TextXs} weight={MDSTextWeight.Medium}>
        <StyledHomeIcon kind={MdsIconKind.Home} />
        Home
      </StyledTabLabel>
    </StyledContainer>
  );
};

const StyledHomeIcon = styled(MdsIcon)`
  .mds-icon {
    font-size: 10px;
    height: 10px;
    width: 10px;
  }
`;

export const StyledContainer = styled.div<{
  $isActive: boolean;
  $isOnlyTab?: boolean;
  $isDragging?: boolean;
  $hasButtons?: boolean;
}>`
  display: flex;
  align-items: center;
  position: relative;
  height: 40px;
  padding: ${({ theme }) => theme.spacing["3"]};
  padding-left: ${({ theme }) => theme.spacing["7"]};
  border-top-left-radius: ${({ theme }) => theme.borderRadius.xlarge};

  width: 94px;
  background-color: ${({ theme }) => theme.colors.background.button.tabBar.default};

  border-bottom: 1px solid
    ${({ theme, $isActive, $isOnlyTab }) =>
      $isActive && !$isOnlyTab ? theme.colors.background.activeTab : "transparent"};

  border-right: 1px solid
    ${({ theme, $isOnlyTab }) => ($isOnlyTab ? "transparent" : theme.colors.border.chrome)};
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.button.tabBar.default};
  }
`;

const StyledTabLabel = styled(MDSText)`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing["0.5"]};
`;
